<template>
  <c-scroll>
    <div class="logInfo pe-24">
      <div class="inputBox">
        <div class="metricNameTitle">
          {{ $util.capitalize($t('label.metricName')) }}
        </div>
        <div class="metricfilter ellipsis" v-lego-tooltip:ellipsis="`metricfilter.${name}`">
          metricfilter.{{ name }}
        </div>
      </div>
      <div class="inputBox">
        <div class="metricNameTitle">
          {{ $util.capitalize($t('label.description')) }}
        </div>
        <lego-text-field
          ref="metricDescription"
          :modelValue="props.description"
          @update:modelValue="changeMetricDescription"
          class="metricInput"
          :counter="1000"
          showCounter
          :rows="6"
          textarea
          v-if="props.mode === 'metricEdit'"
          disableInputMutation
          :rules="[validatorInputDescription]"
          :guide="$t('hint.common')"
        />
        <div v-else class="metricfilter">
          <c-nodata :text="props.description" :showMore="true"></c-nodata>
        </div>
      </div>
      <div class="divider"></div>

      <div class="metric-info">
        <TextItem :label="$t('label.fileName')" :value="selectedLog.logName" />

        <TextItem :label="$t('label.targetName')" :value="selectedLog.productName" />

        <TextItem
          :label="$util.capitalize($t('label.product'))"
          :value="selectedLog.productTypeName"
          :icon="$store.state.iconProductType"
          widthIcon="20"
          withoutPointer
        />

        <TextItem
          :label="$util.capitalize($t('searchLabel.productState'))"
          isHtml
          :value="$util.runningIcon(selectedLog.productState, selectedLog.productState)"
          withoutPointer
        />

        <TextItem :label="$t('searchLabel.ip')" :value="selectedLog.productIpAddress" />
      </div>
    </div>
  </c-scroll>
</template>
<script setup>
import { defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

import TextItem from '@/containers/popup/components/TextItemV2.vue';

const { t } = useI18n();
//emits
const emits = defineEmits(['update:name', 'update:description']);

const props = defineProps({
  name: { type: String },
  description: { type: String },
  selectedLog: { type: Object, default: () => {} },
  detailActive: { type: [String, Object] },
  mode: { type: String }
});

const changeMetricDescription = (value) => {
  emits('update:description', value);
};

const validatorInputDescription = (value) => {
  if (/[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.]/g.test(value)) return t('message.errorValidateInput');
  return true;
};
</script>

<style lang="scss" scoped>
.logInfo {
  display: flex;
  flex-direction: column;
  gap: 36px;
}
.inputBox {
  &:first-child {
    position: relative;
    // margin-bottom: 20px;
    .metricfilter {
      color: #2e3138;
    }
    :deep(.lego-text-field__message.lego-text-field__message--light) {
      position: absolute;
    }
  }
  .metricNameTitle {
    height: 16px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    color: #2e3138;
    font-weight: 700;
  }
}

.divider {
  background: #e3e4e8;
  height: 1px;
}
.metric-info {
  display: flex;
  gap: 32px;
  flex-direction: column;
}
:deep .text-field {
  cursor: unset !important;
}
</style>
